<template>
  <div
    class="dppl-switch"
    :class="{ 'new-version': newVersion, disabled }"
    :style="{ width: `${width}px` }"
    @click="disabled ? () => {} : checkedValue = !checkedValue"
  >
    <div class="button-background-container">
      <button
        type="button"
        class="p2 button-background left-option"
        :class="{ selected: isLeftSelected }"
        :style="{ width: `${width / 2}px` }"
      >
        {{ left }}
      </button>
      <button
        type="button"
        class="p2 button-background right-option"
        :class="{ selected: !isLeftSelected }"
        :style="{ width: `${width / 2}px` }"
      >
        {{ right }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DpplSwitch',
  props: {
    left: {
      type: String,
      required: true,
    },
    right: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: true,
    },
    change: {
      type: Function,
      default: () => {},
    },
    width: { type: Number, default: 120 },
    newVersion: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['change'],
  computed: {
    checkedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('change', newValue);
      },
    },
    isLeftSelected() {
      return this.value;
    },
  },
};
</script>

<style lang="less" scoped>
.dppl-switch {
  height: 36px;
  background: @grey-400;
  border-radius: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;

  &.disabled {
    cursor: default;
    opacity: 0.3;
  }
}

.button-background-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px;
}

.datapeople-app .dppl-switch .p2 {
  font-weight: 400;
  line-height: 32px;
  cursor: pointer;
  color: @text-darkest;
  vertical-align: middle;

  &.button-background {
    color: @text-light;
    font-weight: 300;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 40px;

    &.selected {
     background: @white;
    }
  }
}

.dppl-switch.new-version {
  background: @white;
  height: 45px;
  border-radius: 48px;
  border: 1px solid @stroke-default;

  .button-background-container {
    padding: 6px;
  }

  .p2 {
    font-size: 14px;
    font-weight: 500 !important;
    color: @text-darkest;
    display: flex;
    align-items: center;
    justify-content: center;

    &.button-background {
      color: @text-light;
      height: 33px;
      border-radius: 32px;

      &.selected {
        color: @text-brand;
        background: @bg-canvas !important;
      }
    }
  }
}
</style>
